export function imgLoaded (bool, width = 0, height = 0) {
    return {
        type: 'imgLoaded',
        isLoaded: bool,
        width,
        height
    }
}
export function preloaderDisplay (bool = true) {
    return {
        type: 'preloaderDisplay',
        display: bool
    }
}
export function error (bool = false) {
    return {
        type: 'error',
        error: bool
    }
}
export function currentWeatherLoaded (data) {
    return {
        type: 'setCurrentWeather',
        data
    }
}
export function forecastWeatherLoaded (data) {
    return {
        type: 'setForecastWeather',
        data
    }
}
export function changeCity (cityId) {
    return {
        type: 'changeCity',
        cityId
    }
}